import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { MaterialFieldSettingServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
const mfssp = new MaterialFieldSettingServiceProxy()

@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  extendFieldList = []
  get columns() {
    let extendCols = []
    this.extendFieldList.map(item => {
      if (item.isDisplay === 1) {
        extendCols.push({
          title: item.name,
          dataIndex: item.code,
          width: 100,
          ellipsis: true
        })
      }
    })
    return [
      {
        title: this.$t('page_business_material_barcode'),
        dataIndex: 'barCode',
        key: 'barCode',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_business_material_name'),
        dataIndex: 'materialName',
        key: 'materialName',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_business_material_code'),
        dataIndex: 'materialCode',
        key: 'materialCode',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_business_material_1'),
        dataIndex: 'materialStuff',
        ellipsis: true,
        key: 'materialStuff',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_area'),
        dataIndex: 'areaName',
        key: 'areaName',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_location'),
        dataIndex: 'locationName',
        key: 'locationName',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_extend1'),
        dataIndex: 'extend1',
        key: 'extend1',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_specifications'),
        dataIndex: 'standardModel',
        key: 'standardModel',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_stockNum'),
        dataIndex: 'stockNum',
        key: 'stockNum',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_unit'),
        dataIndex: 'unit',
        key: 'unit',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_stockOutNum'),
        dataIndex: 'stockOutNum',
        key: 'stockOutNum',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_out_extend6'),
        dataIndex: 'returnNum',
        key: 'returnNum',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_material_type'),
        dataIndex: 'materialType',
        key: 'materialType',
        width:200,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_remark'),
        dataIndex: 'remark',
        key: 'remark',
        width:200,
        ellipsis: true
      },
      ...extendCols
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;

  created(): void {
    this.getFieldSetting()
  }

  async getFieldSetting() {
    this.extendFieldList = await mfssp.get()
  }

  render() {
    return (
      <div>
        <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            rowKey="id"
            loading={this.loading}
            scroll={{ y: this.height, x: 2800 }}
        >
        </ml-table>
      </div>
    )
  }
}
